export const TRAINING = {
  TITLE: 'Employees Training',
  TRAINING_RESOURCES: {
    TITLE: 'Resources',
    DESCRIPTION:
      'Access the resource below to complete your training. ' +
      'Follow the instructions provided to ensure successful completion.',
    URLS: {
      WATCH: 'Watch Training Video',
    },
  },
  REPORTS: {
    TITLE: 'Reports',
    DESCRIPTION: 'Download the reports generated after each of the training sessions.',
    DOWNLOAD: {
      Last: 'Download Last Report',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentation',
    DESCRIPTION:
      'Access resources to deepen your understanding of the platform and ' +
      'learn why training can be valuable for your organization.',
    URLS: {
      GUIDE: 'Qalea Documentation',
    },
  },
  INSIGHTS: {
    TITLE: 'Insights',
    DESCRIPTION:
      'Gain valuable insights from your training sessions and assessments. ' +
      "Review results and discover recommended actions to strengthen your organization's security " +
      'by focusing on employee training and development.',
    TRENDS_NOT_YET_AVAILABLE: 'Training sessions not started yet',
  },
}
